<div class="product-article">
  <div class="field">
    <div class="field-text">
      {{ productName }}
    </div>
  </div>
  <div class="field">
    <div class="field-text">
      {{ noteChangePriceData().article }}
    </div>
  </div>
</div>
